import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-find-a-partner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './find-a-partner.html',
  styleUrl: './find-a-partner.css',
})
export class FindAPartnerComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'Find a Partner',
      description: 'Connect with an orderYaa implementation partner for setup, migration, and training.',
      path: '/find-a-partner',
    });
  }
}
